import type { ForNodeType } from "@/components/features/_model/types";

type Props = {
	onlyUseCreditPayment: ForNodeType<boolean>;
	onSetViewModel: (
		values: {
			key: "onlyUseCreditPayment";
			value: ForNodeType<boolean>;
		}[],
	) => void;
};

export const usePlanOnlyUseCreditPayment = ({ onSetViewModel, onlyUseCreditPayment }: Props) => {
	const onSetOnlyUseCreditPayment = (value: boolean) => {
		onSetViewModel([
			{
				key: "onlyUseCreditPayment",
				value: {
					isEdited: true,
					value,
				},
			},
		]);
	};

	return {
		onlyUseCreditPayment,
		onSetOnlyUseCreditPayment,
	};
};
